import { Box, Button, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useCodingScreen } from '../../interface';
import type { CodeType } from '../../interface/transactionCodes';
import { ADD_BUTTON_BORDER, ADD_BUTTON_INDENT, ADD_BUTTON_PX, ADD_BUTTON_PY, INK_MUTED, INK_SOFT } from '../../styles/tokens';

export const ADD_LABEL: Record<CodeType, { text: string; aria: string }> = {
  CPT: { text: '+ Procedure', aria: 'Add procedure' },
  MODIFIER: { text: '+ Modifier', aria: 'Add modifier' },
  ICD: { text: '+ Diagnosis', aria: 'Add diagnosis' }
};

export type AddCodeButtonProps = {
  readonly codeType: CodeType;
  readonly transactionId: string;
};

export const AddCodeButton: React.FC<AddCodeButtonProps> = ({ codeType, transactionId }) => {
  const { bus } = useCodingScreen();
  const [hint, setHint] = useState(false);
  useEffect(() => {
    if (!hint) return;
    const timer = setTimeout(() => setHint(false), 2000);
    return () => clearTimeout(timer);
  }, [hint]);
  return (
    <Box display="inline-flex" alignItems="center" gap="8px" ml={ADD_BUTTON_INDENT}>
      <Button
        variant="ghost"
        size="xs"
        px={ADD_BUTTON_PX}
        py={ADD_BUTTON_PY}
        aria-label={ADD_LABEL[codeType].aria}
        borderWidth="1px"
        borderStyle="dashed"
        borderColor={ADD_BUTTON_BORDER}
        borderRadius="999px"
        color={INK_SOFT}
        fontWeight={500}
        onClick={() => {
          const handled = bus?.emit('addCode.open', { codeType, transactionId }) === true;
          setHint(!handled);
        }}
      >
        {ADD_LABEL[codeType].text}
      </Button>
      {hint && (
        <Text as="span" role="status" fontSize="11px" color={INK_MUTED}>
          Adding a code is not available yet
        </Text>
      )}
    </Box>
  );
};
